import { IChartByUserResponse, IHeadlinesSummaryResponse, IPaymentDueSummaryResponse, IPaymentSummaryResponse, ITeamActionResponse, ITopSuppliersReportResponse } from "../interfaces/dashboard";
import authBaseAxios from "../utils/api";
import qs from "qs";

export const DashboardServices = {
  getTopSuppliersReport: (params: any): Promise<ITopSuppliersReportResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`dashboard/top-suppliers-report?${queryString}`);
  },

  getTopSuppliersError: (params: any): Promise<ITopSuppliersReportResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`dashboard/suppliers-errors?${queryString}`);
  },

  getSirInterventionBySuppliers: (params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`dashboard/sir-intervention-by-supplier-report?${queryString}`);
  },

  getTeamPerformanceByApOwner: (params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`/dashboard/team-performance-by-ap-owner?${queryString}`);
  },

  getSirReviewedBySupplierReport: (params: any): Promise<IChartByUserResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`/dashboard/sir-reviewed-by-supplier-report?${queryString}`);
  },
  getTeamActionReport: (params: any): Promise<ITeamActionResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`/dashboard/team-action-report?${queryString}`);
  },
  getHeadlinesSummary: (params: any): Promise<IHeadlinesSummaryResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`/dashboard/headlines-summary?${queryString}`);
  },
  getPaymentsSummary: (params: any): Promise<IPaymentSummaryResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`/dashboard/payments-summary?${queryString}`);
  },
  getPaymentsDueSummary: (params: any): Promise<IPaymentDueSummaryResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`/dashboard/payments-due-summary?${queryString}`);
  },
  getInvoiceBySupplierReport: (params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`/dashboard/view-invoice-by-supplier-report?${queryString}`);
  },
  getSirMatchingAccuracyBySupplierReport: (params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`/dashboard/view-sir-matching-accuracy-by-supplier-report?${queryString}`);
  },
  getAiPerformanceBySupplierReport: (params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`/dashboard/view-ai-performance-by-supplier-report?${queryString}`);
  },
};
